import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useGetAssets } from "@hooks/use-get/assets";

import { ViewContainer } from "../../components/view-container";
import { AssetTableComponent } from "./asset-table-component";
import { AssetTableContextProvider } from "../../hooks/use-table-context/asset";
import { AddAssetModal } from "./add-asset-modal";
import { fullBleedViewSx } from "../../utils/colors";

export const AssetTable = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState<any>(null);

  const { assetTag } = useParams();
  const { getOneAssetByAssetTag } = useGetAssets();

  const handleOpenModal = (data?: any) => {
    setEditData(data?.id ? data : null);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditData(null);
  };

  useEffect(() => {
    if (!assetTag) return;

    const loadAsset = async () => {
      const asset = await getOneAssetByAssetTag(assetTag);
      return asset;
    };

    loadAsset().then((asset) => handleOpenModal(asset));
  }, [assetTag, getOneAssetByAssetTag]);


  return (
    <AssetTableContextProvider instanceId="page">
      <ViewContainer className="asset-table-view" sx={fullBleedViewSx}>
        <AssetTableComponent openAssetModal={handleOpenModal} />
        <AddAssetModal
          key={editData?.id || "new"}
          open={isModalOpen}
          onClose={handleCloseModal}
          editData={editData}
        />
      </ViewContainer>
    </AssetTableContextProvider>
  );
};
